import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Gallery from "./components/Gallery";
import OrderForm from "./components/OrderForm";
import { OrderProvider } from "./context/OrderContext";
import { AuthProvider } from './context/AuthContext';
import AdminDashboard from './pages/AdminDashboard';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import BackToTop from './components/BackToTop';
import { analytics } from './firebase';
import { logEvent } from 'firebase/analytics';

// Main website component
const MainSite = () => {
  // Analytics - Track page views
  useEffect(() => {
    const referrer = document.referrer;
    if (referrer.includes("youtube.com") || referrer.includes("tiktok.com")) {
      console.log(`📊 Visitor from: ${referrer}`);
    }

    const loadTime =
      window.performance.timing.loadEventEnd -
      window.performance.timing.navigationStart;
    console.log(`📊 Page load time: ${loadTime}ms`);
  }, []);

  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Gallery />
      <OrderForm />

      {/* Contact Section */}
      <section className="contact-section" id="contact">
        <div className="contact-container">
          <h2 className="contact-title">
            <span className="gold-text">Contact Information</span>
          </h2>
          <div className="contact-info">
            <div className="contact-method">
              <div className="contact-icon">📧</div>
              <div className="contact-details">
                <h3>Official Email</h3>
                <a href="mailto:shadiarts.official@gmail.com" className="contact-link">
                  shadiarts.official@gmail.com
                </a>
              </div>
            </div>

            <div className="contact-method">
              <div className="contact-icon">💬</div>
              <div className="contact-details">
                <h3>WhatsApp Business</h3>
                <a
                  href="https://wa.me/201151638804"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  +201151638804
                </a>
              </div>
            </div>

            <div className="contact-method">
              <div className="contact-icon">▶️</div>
              <div className="contact-details">
                <h3>YouTube Channel</h3>
                <a
                  href="https://www.youtube.com/@ShadiArts"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  youtube.com/@ShadiArts
                </a>
              </div>
            </div>

            <div className="contact-method">
              <div className="contact-icon">🎵</div>
              <div className="contact-details">
                <h3>TikTok Account</h3>
                <a
                  href="https://www.tiktok.com/@shadi.arts"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  tiktok.com/@shadi.arts
                </a>
              </div>
            </div>
            
            <div className="contact-method">
              <div className="contact-icon">📸</div>
              <div className="contact-details">
                <h3> Instagram Account</h3>
                <a
                  href="https://www.instagram.com/shadiarts.art"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  instagram.com/shadiarts.art
                </a>
              </div>
            </div>

            <div className="contact-method">
              <div className="contact-icon">📘</div>
              <div className="contact-details">
                <h3> Facebook Page  </h3>
                <a
                  href="https://www.facebook.com/profile.php?id=61591635568693"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                   Shadi Arts
                </a>
              </div>
            </div>
          </div>

          <div className="copyright">
            <p>
              © {new Date().getFullYear()} Shadi Arts. All rights reserved.
            </p>
            <p className="copyright-note">
              Professional Pencil Portrait Artist
            </p>
          </div>
        </div>
      </section>

      <BackToTop />
    </>
  );
};

// 🆕 Analytics wrapper component (MUST be inside Router)
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logEvent(analytics, 'page_view', {
      page_path: location.pathname,
      page_title: document.title,
      page_location: window.location.href
    });
  }, [location]);

  return null;
};

// 🆕 Inner App component that uses useLocation (wrapped by Router)
const AppRoutes = () => {
  return (
    <>
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<MainSite />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <OrderProvider>
            <Router>
              <AppRoutes />
            </Router>
          </OrderProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;